<gd-status-label
  *ngIf="color"
  [color]="color"
  [text]="'txt_financial_order_status_' + status | translate"
  [fluid]="fluid"
  [noShrink]="noShrink"
  [maxWidth]="140"
>
</gd-status-label>
